import React from "react";
import { Box } from "@chakra-ui/react";

type Props = { message: string }

export function ErrorToast({ message }: Props) {
  return (
    <Box
      color='#B5BAC1' px={5} py={3}
      bg='#313338' borderRadius={10}
      fontSize='lg' fontWeight='semibold'
    >
      {message}
    </Box>
  )
}